module.exports = __webpack_public_path__ + "images/application/favicon-1749edb6.ico";